import "./BlueSidemenuBlob.scss";

import React from "react";

export const BlueSidemenuBlob: React.FC = () => <div id="blue-sidemenu-blob" />;
